import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const SwitchHorizontal = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M6.87151 21.0001L3.31623 17.6131C2.89459 17.2114 2.89459 16.5601 3.31623 16.1585L6.87151 12.7715M17.1285 11.2286L20.6838 7.84166C21.1054 7.43997 21.1054 6.78872 20.6838 6.38704L17.1285 3.00006M4.44223 16.8858H20.9074M3.09262 7.11435H19.8277'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M6.35445 12.2285C6.65425 11.9431 7.12831 11.9544 7.41402 12.2539C7.69973 12.5538 7.68854 13.0288 7.38863 13.3145L4.42574 16.1358H20.9072L20.9843 16.1397C21.3624 16.1782 21.6572 16.4976 21.6572 16.8858C21.6572 17.274 21.3624 17.5933 20.9843 17.6319L20.9072 17.6358H4.44234C4.43684 17.6358 4.43121 17.6349 4.42574 17.6348L7.38863 20.4571C7.68854 20.7428 7.69973 21.2177 7.41402 21.5176C7.12832 21.8171 6.65424 21.8285 6.35445 21.543L2.79879 18.1563C2.06691 17.4591 2.06691 16.3125 2.79879 15.6153L6.35445 12.2285ZM17.6455 11.7715C17.3457 12.057 16.8716 12.0457 16.5859 11.7461C16.3002 11.4462 16.3114 10.9713 16.6113 10.6856L17.6455 11.7715ZM16.5859 2.48246C16.8716 2.18296 17.3457 2.1716 17.6455 2.45707L21.2011 5.84378L21.33 5.97953C21.9304 6.68251 21.8873 7.73115 21.2011 8.3848L17.6455 11.7715L16.6113 10.6856L19.5722 7.86429H3.09273C2.67852 7.86429 2.34273 7.52851 2.34273 7.11429C2.34275 6.70009 2.67853 6.36429 3.09273 6.36429H19.5722L16.6113 3.543C16.3114 3.25729 16.3002 2.78236 16.5859 2.48246Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
